import {useEffect, useRef, useState} from 'react'
import styles from './index.module.scss'
interface GroupsProps {
  group: string
}
interface LeftMenuProps {
  groups: GroupsProps[]
  menu: MenuProps[]
  slots?: any
  handleMenuClick?: (data: MenuProps) => void
  router?: any
}
interface GroupProps {
  groupName: string
  children: MenuProps[]
}
interface MenuProps {
  group: string
  name: string
  path: string
  iconclass: string
  meta?: any
}
export const LeftMenu = (props: LeftMenuProps) => {
  const [menuData, setMenuData] = useState<GroupProps[]>([])
  const [currentPathName, setCurrentPathName] = useState('')
  const refVueSlot = useRef<HTMLDivElement>(null)

  const groups = [
    {group: '消息通知'},
    {group: '房间管理'},
    {group: '主持管理'},
    {group: '玩法管理'},
    {group: '用户管理'},
    {group: '推荐管理'},
    {group: '其他管理'},
  ]
  const data = [
    {
      group: '消息通知',
      name: '我的消息',
      path: '/',
      iconclass: 'tongji',
      active: true,
      meta: {role: ['USER']},
    },
    {
      group: '消息通知',
      name: '主持消息',
      path: '/anchormessage',
      iconclass: 'tongji',
      meta: {role: ['ANCHOR', 'OWVOICE']},
    },
    {
      group: '消息通知',
      name: '家族消息',
      path: '/owvoicemessage',
      iconclass: 'tongji',
      meta: {role: ['OWVOICE']},
    },
  ]
  const initMenuData = () => {
    const groupData: GroupProps[] = []
    props.groups.map(group => {
      const info: GroupProps = {
        groupName: group.group,
        children: [],
      }
      props.menu.map(item => {
        if (item.path !== '*' && item.group === group.group) {
          info.children.push(item)
        }
      })
      if (info.children.length > 0) {
        groupData.push(info)
      }
    })
    setMenuData(groupData)
  }
  const initDefaultPathName = () => {
    const pathName = window.location.hash || window.location.pathname
    setCurrentPathName(pathName)
  }
  useEffect(() => {
    initMenuData()
    initDefaultPathName()
  }, [])

  useEffect(() => {
    setCurrentPathName(props?.router?.path)
  }, [props?.router?.path])

  useEffect(() => {
    const vue = props.slots?.$mount()
    if (refVueSlot.current) {
      refVueSlot.current.appendChild(vue.$el)
    }
    return () => {
      refVueSlot.current?.removeChild(vue.$el)
      vue && vue.$destroy()
    }
  }, [])
  // useEffect(() => {
  //   if (refVueSlot.current && props.slots) {
  //     const vue = props.slots.$mount()
  //     refVueSlot.current.appendChild(vue.$el)
  //   }
  // }, [refVueSlot])
  const handleMenuClick = (data: MenuProps) => {
    setCurrentPathName(data.path)
    props.handleMenuClick && props.handleMenuClick(data)
  }

  return (
    <div className={styles.container}>
      {props.slots && <div className={styles.slots} ref={refVueSlot}></div>}
      <div className={`${styles.menuList}`}>
        {menuData.map((menu: GroupProps, index: number) => {
          return (
            <div className={styles.groupMemu} key={index}>
              <div className={styles.group}>{menu.groupName}</div>
              {menu.children.map((child: MenuProps, childIndex: number) => {
                return (
                  <div
                    key={childIndex}
                    className={`${styles.menu} ${currentPathName.indexOf(child.path) > -1 && styles.active}`}
                    onClick={() => handleMenuClick(child)}
                  >
                    {currentPathName.indexOf(child.path) > -1 && (
                      <img src={require(`./img/${child.iconclass}_active.png`)} className={styles.icon} />
                    )}
                    {currentPathName.indexOf(child.path) === -1 && (
                      <img src={require(`./img/${child.iconclass}.png`)} className={styles.icon} />
                    )}
                    {child.name}
                  </div>
                )
              })}
            </div>
          )
        })}
      </div>
    </div>
  )
}
export default LeftMenu
